import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloads lazy routes in the background after the app is stable, so the
 * first navigation into a feature doesn't stall on its chunks (the shared
 * framework+Firebase commons chunk alone is ~220 kB transfer). Rarely
 * visited surfaces opt out with `data: { preload: false }`; their children
 * are then not discovered either.
 */
@Injectable({ providedIn: 'root' })
export class OptOutPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === false ? of(null) : load();
  }
}
